'use es6';

import RequestStatus from 'pricing-pages-unified-ui/constants/RequestStatus';
import createAction from './createAction';
/**
 * Generates a set of action types for use with createRequestActions geared towards requesting data
 *
 * @param {string} requestedDataType A capitalized, underscore-delimited name to uniquely identify the action
 * @param {string} namespace The action namespace
 */

export function createRequestTypes(requestedDataType, namespace) {
  if (namespace) {
    namespace += '/';
  } else {
    namespace = '';
  }

  return {
    REQUEST: `${namespace}REQUESTED_${requestedDataType}`,
    RECEIVE: `${namespace}RECEIVED_${requestedDataType}`,
    FAILURE: `${namespace}REQUESTED_${requestedDataType}_FAILED`
  };
}
export function createRequestActions({
  REQUEST,
  RECEIVE,
  FAILURE
}, {
  receiveMetaCreator,
  failureMetaCreator
} = {}) {
  return {
    requestActionType: REQUEST,
    request: createAction(REQUEST, payload => payload, () => ({
      requestStatuses: {
        [REQUEST]: RequestStatus.PENDING
      }
    })),
    receive: createAction(RECEIVE, (response, props) => ({
      data: response,
      props
    }), (...args) => Object.assign({}, {
      requestStatuses: {
        [REQUEST]: RequestStatus.SUCCEEDED
      }
    }, receiveMetaCreator && receiveMetaCreator(...args))),
    failure: createAction(FAILURE, (error, props) => ({
      error,
      props
    }), (...args) => Object.assign({}, {
      requestStatuses: {
        [REQUEST]: RequestStatus.FAILED
      }
    }, failureMetaCreator && failureMetaCreator(...args)))
  };
}